import { useCertificates } from './useCertificates';
import { getCertificateExpiryStatus } from '../utils/certificateExpiry';
import type { CertificateExpirySummary } from '../utils/certificateExpiry';

/**
 * Combina useCertificates() + getCertificateExpiryStatus() en un solo hook,
 * para que el semaforo de vencimiento se pueda consultar tanto a nivel de
 * pantalla (FiscalInfoTab, badge) como a nivel de layout (AppLayout, pop-up +
 * banner "de entrada" -- ver feedback 2026-08-12: el pop-up dentro de
 * FiscalInfoTab.tsx solo disparaba si el usuario visitaba esa pestaña
 * puntual, por lo que un cliente que nunca entra ahi nunca se enteraba de
 * que su certificado vencio).
 */
export function useCertificateExpiryStatus(): CertificateExpirySummary & { isLoading: boolean } {
  const { data, isLoading } = useCertificates();

  const summary = getCertificateExpiryStatus(
    data?.certificate?.authCertExpiresAt ?? null,
    data?.certificate?.signCertExpiresAt ?? null
  );

  return { ...summary, isLoading };
}
